import { createTheme } from "@mui/material/styles";

export default createTheme({
  palette: {
    background: {
      default: "#F1F3F4",
    },
    primary: {
      main: "#1535BD",
    },
    blue: "linear-gradient(138.72deg, #191E5D 0%, #1535BD 95.83%)",
    blueAlternative: "linear-gradient(120deg, #191E5D 0%, #1535BD 100%)",
  },
  typography: {
    fontFamily: "Mulish, sans-serif",
    fontSize: 15,
    h4: {
      fontWeight: 800,
    },
    h5: {
      fontWeight: 800,
    },
    h6: {
      fontWeight: 800,
    },
    subtitle1: {
      fontWeight: 800,
    },
  },
  mixins: {
    alignInTheCenter: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      position: "relative",
      overflow: "hidden",
      paddingTop: "env(safe-area-inset-top, 0px)",
      paddingBottom: "env(safe-area-inset-bottom, 0px)",
      boxSizing: "border-box",
    },
  },
});
